import { useRef, useState } from "react";
import useIntersectionObserver from "hooks/useIntersectionObserver";
import Image from "./Image";
import "assets/scss/helpers/image.scss";

const ImageContainer = ({ src, alt, thumb, minHeight = "300px", width = "100%" }) => {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useIntersectionObserver({
    target: ref,
    onIntersect: ([{ isIntersecting }], observerElement) => {
      if (isIntersecting) {
        setIsVisible(true);
        observerElement.unobserve(ref.current);
      }
    },
  });

  return (
    <div
      ref={ref}
      className={"imageContainer"}
      style={{
        minHeight: minHeight,
        width: width,
      }}
    >
      {isVisible && (
        <Image src={src} alt={alt} thumb={thumb} />
      )}
    </div>
  );
};

export default ImageContainer;
